// cleanup_class_to_function_GENERICS
// cleanup_convert_to_typescript_file_GENERICS
// cleanup_remove_external_libraries_GENERICS

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';

import { AppConfigContext } from 'components/appConfig/AppConfig';
import { fetchUserPreferences, saveUserPreferences } from 'api/workspace/service';
import { WORKSPACES } from 'constants.js';

import UserPreferencesContext from './UserPreferencesContext';

class UserPreferencesProvider extends Component {
  static contextType = AppConfigContext;

  constructor(props) {
    super(props);
    this.state = {};
  }

  get = (key) =>
    fetchUserPreferences(key).then(({ data, success }) => {
      const { isNative } = this.context;
      // INFO: on native hide widgets added to a workspace via user preferences
      if (isNative && Object.keys(WORKSPACES).includes(key)) {
        return;
      }

      if (!success && data?.[0]?.code === 'CBEX1000') {
        return;
      }

      if (!success || !data.value) {
        return;
      }

      const value = JSON.parse(data.value);
      this.setState({ [key]: value });
    });

  getLocal = (key) => this.state[key];

  set = (key, value) =>
    saveUserPreferences(key, value).then(() => this.setState({ [key]: value }));

  setLocal = (key, value) => {
    if (!isEqual(this.state[key], value)) {
      this.setState({ [key]: value });
    }
  };

  render() {
    const { children } = this.props;
    const { get, getLocal, set, setLocal } = this;
    return (
      <UserPreferencesContext.Provider
        value={{
          get,
          getLocal,
          set,
          setLocal
        }}
      >
        {children}
      </UserPreferencesContext.Provider>
    );
  }
}

UserPreferencesProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.bool,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.bool]))
  ]).isRequired
};

export default UserPreferencesProvider;
